import { Link } from "react-router-dom";
import { BrandLink } from "@/components/Logo";
import { APP_NAME } from "@/lib/config";

const LINKS = [["About", "about"], ["Privacy Policy", "privacy"], ["Terms", "terms"], ["Community Guidelines", "community"], ["Contact", "contact"], ["Safety Guidelines", "safety"]];

export const Footer = () => (
  <footer className="border-t border-border mt-24">
    <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12 flex flex-col md:flex-row gap-8 md:items-end md:justify-between">
      <div className="space-y-3 max-w-sm">
        <BrandLink />
        <p className="text-sm text-muted-foreground">
          AI-written suggestions for adults. You decide what to send — {APP_NAME} never messages anyone for you.
        </p>
      </div>
      <nav className="flex flex-wrap gap-x-6 gap-y-2 text-sm">
        {LINKS.map(([label, slug]) => (
          <Link key={slug} to={`/legal/${slug}`} data-testid={`footer-link-${slug}`} className="text-muted-foreground hover:text-foreground transition-colors">
            {label}
          </Link>
        ))}
      </nav>
    </div>
    <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 pb-8 text-xs text-muted-foreground">© {new Date().getFullYear()} {APP_NAME}. Suggestions only — no guarantees about anyone's feelings or responses.</div>
  </footer>
);
